import { ReactNode } from "react";

import { ReadCvLogo } from "@phosphor-icons/react";
import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Slider,
  Switch,
} from "@reactive-resume/ui";
import { useCoverLetterStore } from "@/client/stores/cover-letter";

import { CLCollapsibleSection } from "../../../CollapsibleSection";

export const CLPageSection = () => {
  const setValue = useCoverLetterStore((state) => state.setValue);
  const page = useCoverLetterStore((state) => state.coverLetter.data.metadata.page);

  const headerHTML: ReactNode = (
    <div className="flex items-center gap-x-4">
      <ReadCvLogo size={18} />
      <h2 className="line-clamp-1 text-base font-bold text-gray-800 lg:text-lg">Page</h2>
    </div>
  );

  const contentHTML: ReactNode = (
    <main className="grid gap-y-6">
      <div className="space-y-1.5">
        <Label>Format</Label>
        <Select
          value={page.format}
          onValueChange={(value) => setValue("metadata.page.format", value)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Format" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="a4">A4</SelectItem>
            <SelectItem value="letter">Letter</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-1.5">
        <Label>Left & Right Margin</Label>
        <div className="flex items-center gap-x-4 py-1">
          <Slider
            min={0}
            max={48}
            step={2}
            value={[page.margin]}
            onValueChange={(value) => setValue("metadata.page.margin", value[0])}
          />
          <span className="text-base font-bold">{page.margin}</span>
        </div>
      </div>
    </main>
  );

  return <CLCollapsibleSection id="cl-page" header={headerHTML} content={contentHTML} />;
};
